import { lazy, Suspense, useState, useEffect, FunctionComponent } from 'react';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { FormattedMessage } from 'dibs-react-intl';
import Contact1stdibsModal from '../../contact1stdibs/Contact1stdibsModal';
import { Link } from 'dibs-elements/src/Link';

import styles from './Contact1stdibsLink.scss';

import { Contact1stdibsLink_viewer as ViewerType } from './__generated__/Contact1stdibsLink_viewer.graphql';

const TradeRepCircle = lazy(
    () =>
        import(
            /* webpackChunkName: "Contact1stdibsModalTradeRepCircle" */ 'dibs-sales-rep/exports/TradeRepCircle'
        )
);

type ReduxStoreType = {
    header: {
        isNavigationRefreshVariant: boolean;
    };
};

type Contact1stdibsLinkProps = {
    hasUserId: boolean;
    hasRootPendingRefetch: boolean;
    isUserTypeTrade: boolean;
    viewer: ViewerType;
    isNavigationRefreshVariant: boolean;
    isNavigationHovered: boolean;
};

const Contact1stdibsLink: FunctionComponent<Contact1stdibsLinkProps> = ({
    hasUserId,
    hasRootPendingRefetch,
    isUserTypeTrade,
    viewer,
    isNavigationRefreshVariant,
    isNavigationHovered,
}) => {
    const [isContactModalOpen, setIsContactModalOpen] = useState(false);
    const [didMount, setDidMount] = useState(false);
    useEffect(() => {
        setDidMount(true);
    }, []);
    const renderTradeCirlce =
        isUserTypeTrade &&
        hasUserId &&
        didMount &&
        !hasRootPendingRefetch &&
        !isNavigationRefreshVariant;
    const wrapperClassName = classNames(styles.wrapper, {
        [styles.navigationRefreshWrapper]: isNavigationRefreshVariant,
        [styles.hoveredNavigation]: isNavigationRefreshVariant && isNavigationHovered,
    });

    return (
        <>
            <div className={wrapperClassName}>
                <Link
                    className={styles.container}
                    onClick={() => {
                        setIsContactModalOpen(true);
                    }}
                >
                    {renderTradeCirlce ? (
                        <div className={styles.iconWrapper}>
                            <Suspense fallback={null}>
                                <TradeRepCircle theme="dark" viewer={viewer} />
                            </Suspense>
                        </div>
                    ) : null}
                    {/* element below is used as an anchor for `ContactTradeRepTooltip.tsx`, hence the ID */}
                    <div
                        className={styles.contact1stdibs}
                        data-tn="contact-1stdibs-link"
                        id="trade-spec"
                    >
                        <FormattedMessage
                            id="dbl.contact1stdibsLink.contact1stdibs"
                            defaultMessage="Contact 1stDibs"
                        />
                    </div>
                </Link>
            </div>

            <Contact1stdibsModal
                isOpen={isContactModalOpen}
                placement="globalNav"
                onClose={() => setIsContactModalOpen(false)}
            />
        </>
    );
};

const mapStateToProps = ({
    header,
}: ReduxStoreType): {
    isNavigationRefreshVariant: boolean;
} => {
    const { isNavigationRefreshVariant } = header;
    return {
        isNavigationRefreshVariant,
    };
};

export default createFragmentContainer(connect(mapStateToProps)(Contact1stdibsLink), {
    viewer: graphql`
        fragment Contact1stdibsLink_viewer on Viewer {
            ...TradeRepCircle_viewer @include(if: $hasTradeUserId) @defer
        }
    `,
});
